/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostspercredit3Inputs */

const en_aicostspercredit3 = /** @type {(inputs: Aicostspercredit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost per credit`)
};

const de_aicostspercredit3 = /** @type {(inputs: Aicostspercredit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten je Credit`)
};

/**
* | output |
* | --- |
* | "Cost per credit" |
*
* @param {Aicostspercredit3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostspercredit3 = /** @type {((inputs?: Aicostspercredit3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostspercredit3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostspercredit3(inputs)
	return de_aicostspercredit3(inputs)
});
export { aicostspercredit3 as "aiCostsPerCredit" }